import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    switchRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    footerActionContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    uploadPlaceholder: {
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    },
    logoUploadBox: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 160
    },
    sectionContainer: {
        flexDirection: "column",
        width: "100%"
    },
    sectionHeader: {
        flexDirection: "column",
        width: "100%"
    },
    formCard: {
        flexDirection: "column",
        overflow: "hidden",
        width: "100%"
    },
    formBody: {
        flexDirection: "column",
        width: "100%"
    },
    container: {
        flexDirection: "column",
        width: "100%",
        flex: 1
    },
    switchTextContainer: {
        flexDirection: "column",
        flex: 1
    },
    uploadDimensions: {
        textAlign: "center"
    },
    sectionTitle: {
        fontWeight: "700"
    },
    sectionSubtitle: {
        fontWeight: "400"
    },
    uploadLabel: {
        fontWeight: "600"
    },
    uploadedImage: {
        height: "100%",
        width: "100%"
    },
    uploadRow: {
        width: "100%"
    }
});

export default stylesheet;
